import { type Fee, FeeCalcTypeEnum } from 'reservations/booking/types';

export const PER_GUEST = 'per guest';

export const getFeeText = (calcType: Fee['calcType']): string =>
  calcType === FeeCalcTypeEnum.enum.PartySize ? PER_GUEST : '';
